module.exports = __webpack_public_path__ + "static/media/pc1.9aa4fab5.png";